import { emptyPatient } from 'app/Bookings/utils'
import {
  START_BOOKING,
  SET_PATIENTS_FOR_USER,
  UPDATE_BOOKING_HELPER_FILTERS,
  SET_SELECTED_PATIENTS,
  UPDATE_BOOKING_DETAILS,
  CLEAN_BOOKING_INFO,
  SET_DROPDOWN_PATIENTS,
  UPDATE_BOOKING_HELPER_DETAILS,
  ADD_NEW_PATIENTS,
  RESET_PATIENT_FORM,
  COMPLETE_BOOKING,
  SET_B2B_DETAILS,
  SET_RP_DETAILS,
  SET_SALESFORCE_DETAILS,
  SET_SKIP_EMAIL_USER_DETAILS,
  CLEAR_SALESFORCE_DETAILS,
} from './constants'

//------------------Actions on Booking Helper State-------------------
export const startBooking = (
  payload: BookingHelperState
): ReducerActions<BookingHelperState> => {
  return {
    type: START_BOOKING,
    payload,
  }
}

export const setSalesforceDetails = (
  payload: SalesforceDetails
): ReducerActions<SalesforceDetails> => {
  return {
    type: SET_SALESFORCE_DETAILS,
    payload,
  }
}

export const clearSalesforceDetails = (): ReducerActions<SalesforceDetails> => {
  return {
    type: CLEAR_SALESFORCE_DETAILS,
  }
}

export const setPatientsForUser = (
  patients: PatientInfo[]
): ReducerActions<PatientInfo[]> => {
  return {
    type: SET_PATIENTS_FOR_USER,
    payload: patients,
  }
}

export const updateBookingHelperFilters = (
  helperFilters: BookingHelperFilters
): ReducerActions<BookingHelperFilters> => {
  return {
    type: UPDATE_BOOKING_HELPER_FILTERS,
    payload: helperFilters,
  }
}

export const updateBookingHelperDetails = (details: {
  [key: string]: string | boolean | Provider | SelectedSlot | User
}): ReducerActions<{
  [key: string]: string | boolean | Provider | SelectedSlot | User
}> => {
  return {
    type: UPDATE_BOOKING_HELPER_DETAILS,
    payload: details,
  }
}

export const setDropdownPatients = (
  patients: PatientInfo[]
): ReducerActions<PatientInfo[]> => {
  return {
    type: SET_DROPDOWN_PATIENTS,
    payload: patients,
  }
}

export const setB2BDetails = (
  b2bDetails?: B2BDetails
): ReducerActions<B2BDetails> => ({
  type: SET_B2B_DETAILS,
  payload: b2bDetails,
})

export const completeBooking = (): ReducerActions<boolean> => {
  return {
    type: COMPLETE_BOOKING,
    payload: true,
  }
}

//-------------------Actions on Booking State-----------------------
export const updateBookingDetails = (details: {
  [key: string]: string | boolean
}): ReducerActions<{ [key: string]: string | boolean }> => {
  return {
    type: UPDATE_BOOKING_DETAILS,
    payload: details,
  }
}

export const setSelectedPatients = (
  patients: PatientInfo[]
): ReducerActions<PatientInfo[]> => {
  return {
    type: SET_SELECTED_PATIENTS,
    payload: patients,
  }
}

export const updateResponsibleParty = (
  responsibleParty: Partial<UserExistsResponse>
): ReducerActions<Partial<UserExistsResponse>> => {
  return {
    type: SET_RP_DETAILS,
    payload: responsibleParty,
  }
}

export const setSkipEmailUserDetails = (skipEmailUserDetails: {
  id: string
  email: string
  isNewUser: boolean
}): ReducerActions<SkipEmailUserDetails> => ({
  type: SET_SKIP_EMAIL_USER_DETAILS,
  payload: skipEmailUserDetails,
})

//-------------------Actions on Booking Helper No Persist State-----------------------
export const addNewPatients = (
  count = 1,
  hydrationData: Partial<PatientInfo> = emptyPatient
): ReducerActions<AddPatientPayload> => {
  return {
    type: ADD_NEW_PATIENTS,
    payload: { count, hydrationData },
  }
}

export const resetPatientForm = (action: boolean): ReducerActions<boolean> => {
  return {
    type: RESET_PATIENT_FORM,
    payload: action,
  }
}

//---------------------Common Actions------------------
export const cleanBookingInfo = (
  isSalesforceOrThirdPartyAgent?: boolean
): ReducerActions<boolean | void> => {
  return {
    type: CLEAN_BOOKING_INFO,
    payload: isSalesforceOrThirdPartyAgent,
  }
}
